import axiosInstance from "../Services/axiosInstance"


export const submitFeedBackApi=async(data)=>{

   try {
        const response =axiosInstance.post('/chat/upload_question/',data)
        return response;
   } catch (error) {
        console.error("Error submitting feedback:", error);
        throw error;
   }


}

export const submitQuery=async(data)=>{

    try {
         const response =axiosInstance.post('/chat/new-mentalhealth-bot/',data)
         return response;
    } catch (error) {
         console.error("Error submitting feedback:", error);
         throw error;
    }
 
 
 }

 export const getUserChatHistory=async(userId)=>{

    try {
         const response =axiosInstance.get(`/chat/user_sessions/?user_id=${userId}`)
         return response;
    } catch (error) {
         console.error("Error getting chat history:", error);
         throw error;
    }
 
 
 }


 export const getUserChatHistoryWithUserSession=async(userId , user)=>{
    
     try {
          const response =axiosInstance.get(`/chat/chat_history/?user_id=${userId}&session_id=${user}`)
          return response;
     } catch (error) {
          console.error("Error getting chat history:", error);
          throw error;
     }
  
  
  }

  export const acceptPrivacyPolicyApi=async(data)=>{
     console.log( "acceptPrivacyPolicyApi data :::::::::::::::::::::::::;;;", data);

    try {
         const response =axiosInstance.patch(`/auth/provider/${data.user_id}` , data)
         return response;
    } catch (error) {
         console.error("Error accepting privacy policy:", error);
         throw error;
    }
 
 
 }
